import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';
import { computed } from 'vue';
import { useHierarchy } from '@/store/hierarchy.ts';

export const useProductCategories = defineStore('product-categories', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.productCategory_GetBrandProductCategories,
    dto: 'ProductCategoryDto',
    create: api.productCategory_AddProductCategory,
    update: api.productCategory_UpdateProductCategory,
    delete: api.productCategory_DeleteProductCategory,
    usage: api.productCategory_GetProductCategoryUsage,
    signalR: 'ProductCategoryUpdate',
  });

  const { loaded } = globalStoreBase;

  const categoryAvailableOnAllNodes = computed(() => {
    const allRestrictedCategories = useHierarchy().fullNodes.flatMap((node) => node.productCategoryIds);
    return loaded.value.filter((productCategory) => !allRestrictedCategories.includes(productCategory.id));
  });

  return {
    ...globalStoreBase,
    loaded,
    categoryAvailableOnAllNodes,
  };
});
